import React, { createElement, Fragment } from 'react';
import ProCard from '@/components/layout/pro-card';
import { Field, Table, Form, Tag, Button, ResponsiveGrid, Input, Select, TreeSelect } from '@alifd/next';
import request from '@/utils/request';
import { drop, set, isEmpty } from 'lodash-es';
import { nanoid } from 'nanoid';
const AccountingEventEntityMapping = (props) => {
    const [dataSource, setDataSource] = React.useState([]);
    const [jsonSchemaTreeData, setJsonSchemaTreeData] = React.useState([]);
    const [selectedRows, setSelectedRows] = React.useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);
    const { blockProps, field, formProps, __designMode, mapListName, targetAndSourceCfgList = [], title, editType } = props;
    const { columns, spacing, status } = formProps;
    const isPreview = status === 'readonly' || editType === 'view';
    const isDesign = __designMode === 'design';
    const schema = React.useRef({
        type: 'object',
        properties: {}
    });
    const formField = Field.useField({
        parseName: true,
    });
    const columnsTable = [
        {
            title: '服务配置实体属性',
            dataIndex: 'targetParam',
            width: 300,
        },
        {
            title: '数据来源',
            dataIndex: 'dataSrcCd',
            width: 300,
            cell: (val) => {
                const dataSrcCdEnums = {
                    '900800000040': '源请求实体参数'
                };
                return createElement("span", null, dataSrcCdEnums[val]);
            }
        },
        {
            title: '数据对象',
            dataIndex: 'sourceParam',
            width: 300,
        },
    ];
    const { refValue, refValueUrl } = targetAndSourceCfgList.filter(item => item.name === 'targetParam')[0] || {};
    const { refValue: refValuesourceParam, refValueUrl: refValueUrlsourceParam } = targetAndSourceCfgList.filter(item => item.name === 'sourceParam')[0] || {};
    const targetParamcode = field.getValue(refValue);
    const sourceParamcode = field.getValue(refValuesourceParam);
    const querySourceSelect = async () => {
        const sourceParamcodes = field.getValue(refValuesourceParam);
        const { content: contentsourceParam = [] } = await request.get(refValueUrlsourceParam);
        const { entityCode: entityCdSourceParam } = contentsourceParam?.filter(({ code }) => code === sourceParamcodes)[0] || {};
        if (!isEmpty(entityCdSourceParam)) {
            const { content: contentSourceParaSchema } = await request(`/api/exchange/entity/extend/${entityCdSourceParam}`);
            const schemaSource = contentSourceParaSchema?.bigData?.dataContent || '{}';
            const dataObjDataSource = transformSchemaTreeSelect(JSON.parse(schemaSource));
            setJsonSchemaTreeData(dataObjDataSource);
        }
    };
    const queryTargetTree = React.useCallback(async () => {
        const targetParamcodes = field.getValue(refValue);
        let params = [];
        if (refValueUrl === '/api/decision/config/summary/us') {
            const { content: contentTargetParam = [] } = await request.get(refValueUrl, {
                params: { usageScenario: '902900000003' },
            });
            params = contentTargetParam;
        }
        else {
            const { content: contentTargetParam = [] } = await request.get(refValueUrl);
            params = contentTargetParam;
        }
        const { entityCode: entityCdTargetParam } = params?.filter(({ code }) => code === targetParamcodes)[0] || {};
        if (!isEmpty(entityCdTargetParam)) {
            const { content: contentTargetParamSchema } = await request(`/api/exchange/entity/extend/${entityCdTargetParam}`);
            const datasTarget = contentTargetParamSchema?.bigData?.dataContent || '{}';
            const schemaTarget = JSON.parse(datasTarget);
            const data = transformSchemaTree(schemaTarget);
            setDataSource(data);
            schema.current = schemaTarget;
        }
        querySourceSelect();
    }, []);
    const queryReplaceData = (data = []) => {
        const replaceData = data.map(item => {
            const { sourceParam } = item;
            if (!isEmpty(sourceParam)) {
                const replaceValue = sourceParam.replace('{}', '').replace(/({\w+})/, (match) => {
                    const index = match.slice(1, -1);
                    return `[].${index}`;
                });
                return {
                    ...item,
                    sourceParam: replaceValue
                };
            }
            return item;
        });
        return replaceData;
    };
    React.useEffect(() => {
        const { value = '' } = field?.init(mapListName);
        if (!isEmpty(value)) {
            const schemasValue = JSON.parse(value);
            const data = transformSchemaTree(schemasValue);
            const replaceData = queryReplaceData(data);
            setDataSource(replaceData);
            schema.current = schemasValue;
            querySourceSelect();
        }
        if (isEmpty(targetParamcode)) {
            setDataSource([]);
        }
        if (isEmpty(value) && !isEmpty(targetAndSourceCfgList) && !isEmpty(targetParamcode)) {
            queryTargetTree();
        }
    }, [queryTargetTree, field, mapListName, targetAndSourceCfgList, refValue, refValuesourceParam, targetParamcode, sourceParamcode]);
    const resetSelectedRows = () => {
        setSelectedRowKeys([]);
        setSelectedRows([]);
    };
    const cancle = () => {
        resetSelectedRows();
    };
    const save = () => {
        formField.validate((errors, values) => {
            if (isEmpty(errors)) {
                const data = transformSchemaTree(schema.current);
                const replaceData = data.map(item => {
                    const { sourceParam } = item;
                    if (!isEmpty(sourceParam)) {
                        const replaceValue = sourceParam.replace('{}', '').replace(/({\w+})/, (match) => {
                            const index = match.slice(1, -1);
                            return `[].${index}`;
                        });
                        return {
                            ...item,
                            sourceParam: replaceValue
                        };
                    }
                    return item;
                });
                setDataSource(replaceData);
                resetSelectedRows();
            }
        });
    };
    const submit = () => {
        save();
        const submitScheme = JSON.stringify(schema.current);
        field.setValue(mapListName, submitScheme);
        resetSelectedRows();
    };
    const onChange = async (val, dataIndex) => {
        if (dataIndex === 'dataSrcCd') {
            formField.setValue('sourceParam', '');
        }
        const { setKey } = selectedRows[0] || {};
        const path = [].concat(setKey, dataIndex).join('.');
        set(schema.current, path, val);
    };
    const onRowChange = (selectedRowKey, records) => {
        setSelectedRowKeys(selectedRowKey);
        setSelectedRows(records);
        const { sourceParam, dataSrcCd } = records[0] || {};
        formField.setValues({
            ...records[0],
            sourceParam: sourceParam ?? '',
            dataSrcCd: dataSrcCd ?? '',
        });
    };
    const rowSelection = {
        mode: 'single',
        onChange: onRowChange,
        selectedRowKeys,
        getProps: () => {
            return {
                disabled: isDesign || isPreview,
            };
        },
    };
    return (createElement(Fragment, null,
        createElement(ProCard, { ...blockProps, title: title },
            createElement("div", null,
                createElement(Table, { dataSource: dataSource, columns: columnsTable, rowSelection: rowSelection, primaryKey: "key", isTree: true }),
                ((isDesign || selectedRows.length > 0) && !isPreview) && (createElement(Form, { isPreview: isPreview, field: formField, useLabelForErrorMessage: true, labelAlign: "left", fullWidth: false },
                    createElement(ResponsiveGrid, { gap: spacing, columns: columns },
                        createElement(Form.Item, { labelAlign: "left", label: "\u670D\u52A1\u914D\u7F6E\u5B9E\u4F53\u5C5E\u6027", name: "targetParam", size: "medium", fullWidth: true },
                            createElement(Input, { placeholder: "\u8BF7\u8F93\u5165", size: "medium", disabled: true })),
                        createElement(Form.Item, { labelAlign: "left", label: "\u6570\u636E\u6765\u6E90", name: "dataSrcCd", size: "medium", fullWidth: true, required: true },
                            createElement(Select, { placeholder: "\u8BF7\u9009\u62E9\u6570\u636E\u6765\u6E90", size: "medium", dataSource: [
                                    { label: '源请求实体参数', value: '900800000040' },
                                ], onChange: (val) => onChange(val, 'dataSrcCd') })),
                        createElement(Form.Item, { labelAlign: "left", label: "\u6570\u636E\u5BF9\u8C61", name: "sourceParam", size: "medium", fullWidth: true, required: true },
                            createElement(TreeSelect, { placeholder: "\u8BF7\u9009\u62E9\u6570\u636E\u5BF9\u8C61", size: "medium", dataSource: jsonSchemaTreeData, showSearch: true, hasClear: true, onChange: (val) => onChange(val, 'sourceParam') }))),
                    isPreview ? null : (createElement("div", { style: { textAlign: 'center' } },
                        createElement(Button.Group, null,
                            createElement(Button, { type: "primary", key: nanoid(), onClick: submit, disabled: isDesign }, "\u4FDD\u5B58"),
                            createElement(Button, { onClick: cancle }, "\u53D6\u6D88"))))))))));
};
export default AccountingEventEntityMapping;
const transformSchemaTreeSelect = (schema = {}) => {
    if (!schema) {
        return [];
    }
    const { properties, type, items, pathPrefix = 'properties', dataPrefix = 'properties', parentType = 'object', parentDataPrefix = null, rootType = null, level = 0, } = schema;
    if (type === 'object') {
        const data = Object.keys(properties).map((key) => {
            const el = properties[key];
            console.log('hhh', el);
            const { type, description = '', required = false, dict, dataSourceType, dataSrcCd, sourceParam, } = el;
            const _pathKey = [].concat(pathPrefix, key, 'properties').join('.');
            const _setKey = [].concat(pathPrefix, key).join('.');
            const _dataKey = [].concat(dataPrefix, type === 'array' ? `${key}[]` : key).join('.');
            const _parentdataKey = [].concat(dataPrefix, key).join('.');
            const options = {
                ...el,
                pathPrefix: _pathKey,
                dataPrefix: _dataKey,
                parentType: type,
                parentDataPrefix: _parentdataKey,
                rootType: type,
                level: level + 1,
                dataSourceType,
            };
            const children = transformSchemaTreeSelect(options).length === 0 ? null : transformSchemaTreeSelect(options);
            const label = () => {
                let color = 'blue';
                if (type !== 'object' || type !== 'array') {
                    color = 'green';
                }
                const title = isEmpty(description) ? `${key}` : `${key}(${description})`;
                return (createElement("div", { style: { display: 'flex' } },
                    createElement("div", { style: { marginRight: 8, fontWeight: 'bold' } }, title),
                    createElement("div", null,
                        createElement(Tag, { type: "primary", size: "small", color: color }, type))));
            };
            const value = drop(_dataKey.split('.')).join('.');
            return {
                key: _pathKey,
                type,
                name: key,
                required,
                description,
                parentKey: pathPrefix,
                parentType,
                dataKey: _dataKey,
                dict,
                parentDataPrefix,
                rootType: rootType || type,
                level,
                dataSourceType,
                label: label(),
                value,
                children,
                sourceParam,
                dataSrcCd,
                targetParam: key,
                setKey: _setKey
            };
        });
        return data;
    }
    else if (type === 'array') {
        const arrayPrefix = pathPrefix.split('.');
        arrayPrefix.pop();
        const finalPrefix = [].concat(arrayPrefix, 'items', 'properties').join('.');
        return transformSchemaTreeSelect({
            ...items,
            pathPrefix: finalPrefix,
            dataPrefix,
            parentType,
            parentDataPrefix,
            rootType,
            level,
        });
    }
    return [];
};
const transformSchemaTree = schema => {
    const { properties = {}, type, items, pathPrefix = 'properties', preDescription = '', dataPrefix = 'properties', parentType = 'object' } = schema || {};
    if (type === 'object') {
        const data = Object.keys(properties).map(key => {
            const el = properties[key];
            const _pathKey = [].concat(pathPrefix, key, 'properties').join('.');
            const _setKey = [].concat(pathPrefix, key).join('.');
            const { mandInd = false, type, disabled = false, description, dataSrcCd, sourceParam } = el;
            const _description = []
                .concat(preDescription, description)
                .filter(i => !!i)
                .join('/');
            const _dataKey = []
                .concat(dataPrefix, type === 'array'
                ? `${key.replace(/({\w+})/, match => {
                    const index = match.slice(1, -1);
                    return `[].${index}`;
                })}`
                : key)
                .join('.');
            const options = {
                ...el,
                pathPrefix: _pathKey,
                preDescription: _description,
                dataPrefix: _dataKey,
                parentType: type
            };
            const children = isEmpty(transformSchemaTree(options)) ? null : transformSchemaTree(options);
            return {
                key: _pathKey,
                type,
                targetParam: key,
                dataSrcCd,
                sourceParam,
                mandInd,
                disabled,
                description: _description,
                parentKey: pathPrefix,
                dataKey: _dataKey,
                parentType,
                children,
                setKey: _setKey
            };
        });
        return data;
    }
    else if (type === 'array') {
        const arrayPrefix = pathPrefix.split('.');
        arrayPrefix.pop();
        const finalPrefix = [].concat(arrayPrefix, 'items', 'properties').join('.');
        return transformSchemaTree({ ...items, pathPrefix: finalPrefix, preDescription });
    }
    return [];
};
